<template>
  
</template>
<script>
export default {
  created() {
    if(window.location.search.includes('find_car_uuid')) this.reactivateCarSeach(this.get('find_car_uuid'))
  },
  methods: {
    /**
    * Gets param value sent via HTTP GET
    *
    * @author Giovanny Noé González Pelayo <giovanny@autodeal.mx>
    * @param string name
    * @return string
    */
    get(name) {
        if(name=(new RegExp('[?&]'+encodeURIComponent(name)+'=([^&]*)')).exec(location.search))
            return decodeURIComponent(name[1]);
    },
    /**
    * Sends a POST request to backend to reactivate the find_car with given id
    *
    * @author Giovanny Noé González Pelayo <giovanny@autodeal.mx>
    * @return void
    */
    async reactivateCarSeach(uuid) {
      try {
        await axios.patch(`client/find/car/${uuid}/reactivate`)
        this.$swal({
          icon: "success",
          title: null,
          text: 'Alerta reactivada por 15 días'
        })
      } catch (error) {
        console.error(error)
        this.$swal({
          icon: "error",
          title: null,
          text: 'Error al reactivar la alerta de búsqueda de auto'
        })
      }
    }
  }
}
</script>